import Vue from "vue";
export default Vue.component('checkout-shipping-address-select', {

    delimiters: ['${', '}'],

    props: [
        'selectedAddressId',
        'addressList',
        'template'
    ],

    computed: Vuex.mapState({
        deliveryAddressId: state => state.address.deliveryAddressId
    }),

    created() {

        this.$options.template = this.template;

        if (!this.addressList) {
            this.addressList = [];
        }

        // Adds the dummy entry for 'delivery address same as invoice address'
        this.addressList.unshift({id: -99});
        this.$store.dispatch('initDeliveryAddress', {
            id: this.selectedAddressId === 0 ? -99 : this.selectedAddressId,
            addressList: this.addressList
        });
    },

    methods: {

        addressChanged(selectedAddress) {

            this.$store.dispatch('selectAddress', {selectedAddress, addressType: '2'})
                .then(response => {
                        document.dispatchEvent(new CustomEvent('afterDeliveryAddressChanged', {detail: this.deliveryAddressId}));
                    }, error => {

                    }
                );
        }
    }
});
